import ConditionName from './ConditionName';

export default ConditionName;
export { ConditionName };
